import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from './icon';
import InfoIcon from '@assets/icons/info.svg';

export const ExchangeRate = () => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  const { t } = useTranslation();

  return (
    <div className='relative flex items-center justify-center'>
      <Icon
        className='cursor-pointer rounded-full'
        icon={<InfoIcon className='text-primary' width='16' height='16' />}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      />
      {isHovered && (
        <div className='absolute left-40 w-64 -translate-x-1/2 transform bg-light p-3 text-soft-black'>{t('exchangeRate.description')}</div>
      )}
    </div>
  );
};
